/**
 * PATH: apps/quote/src/components/builder/panels/takeoff-assist/SearchResultItem.tsx
 * PURPOSE: Search result item for application search
 */

import { useState } from 'react'
import { Check, Plus, Star } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { Application } from '@/lib/quoteApi'

export default function SearchResultItem({
  application, onSelect, onAddAsNew, isSelected,
}: {
  application: Application; onSelect: () => void; onAddAsNew: () => void; isSelected: boolean
}) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      className={cn('p-2.5 rounded-lg border transition-all cursor-pointer', isSelected ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' : 'border-transparent hover:bg-slate-50 dark:hover:bg-slate-800')}
      onClick={onSelect} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5">
            <span className="text-sm font-medium text-slate-900 dark:text-white">{application.name || application.code}</span>
            {application.is_popular && <Star className="w-3 h-3 text-amber-500 fill-amber-500" />}
          </div>
          <p className="text-xs text-slate-500 mt-0.5 line-clamp-1">{application.supplier_name} • {application.substrate_type}</p>
          <div className="flex items-center gap-2 mt-1.5">
            <span className="text-[10px] px-1.5 py-0.5 bg-slate-100 dark:bg-slate-800 rounded">{application.area_type}</span>
            <span className="text-[10px] text-slate-400">{application.productivity_m2_per_day} m²/day</span>
          </div>
        </div>
        {(isHovered || isSelected) && (
          <div className="flex items-center gap-1 shrink-0">
            <button onClick={(e) => { e.stopPropagation(); onSelect() }} className="p-1.5 bg-blue-600 text-white rounded hover:bg-blue-700" title="Apply to selected row">
              <Check className="w-3.5 h-3.5" />
            </button>
            <button onClick={(e) => { e.stopPropagation(); onAddAsNew() }} className="p-1.5 bg-slate-600 text-white rounded hover:bg-slate-700" title="Add as new row">
              <Plus className="w-3.5 h-3.5" />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
